import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "controls-footer__wrapper" }
const _hoisted_2 = { class: "controls-footer__section" }

import Cta from './shared/Cta.vue';
import { computed, onMounted } from 'vue';
import { LockDesignerPDF } from 'Api/apis';
import { useStore } from 'vuex';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import { OptionChanged } from 'Vue/interfaces/LockDesigner';
import AdvancedFiltersModal from './shared/Modals/AdvancedFiltersModal.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const componentName = 'ControlsFooter';
const store = useStore();

const toast = useToast();
const router = useRouter();
//const savedAuthToken = ref(localStorage.getItem('authToken') || '');

const addToWishlist = () => {
    //If the user is logged in go to the wishlist
    //If not then prompt them to login
    if (store?.state?.authToken) {
        router.push('/lock-designer/wishlist-add');
    } else {
        router.push('/lock-designer/login');
    }
};

const share = () => {
    router.push('/lock-designer/share');
};

const requestObject = computed(() => {
    return {
        selections: store?.state?.selections,
        optionChanged: OptionChanged.None,
        exterior: store?.state?.selections?.exterior,
    };
});

const print = async () => {
    toast.success(`A PDF of your Baldwin Lock Designer Configuration is currently generating. This may take a few minutes. Upon completion open the PDF to print.`, {
        timeout: false,
    });
    await LockDesignerPDF(requestObject.value).then((response) => {
        setTimeout(() => {
            toast.clear();
        }, 3000);
    });
};
const handleAdvancedFilters = async() => {
    await store.dispatch('openModal', { component: AdvancedFiltersModal });
};

const download = () => {
    let downloadImage = () => {
        let imageUrl = store?.state?.selections?.scene7ImageUrl ? `${store?.state?.selections?.scene7ImageUrl}&fmt=png-alpha` : 'https://images.baldwinhardware.com/is/image/Baldwin/lockdesigner-error';
        let fileName = 'lock-designer-image.png';

        // Create a link element
        let link = document.createElement('a');

        // Fetch the image as a Blob
        fetch(imageUrl)
            .then((response) => response.blob())
            .then((blob) => {
                // Create a Blob URL
                // Set the link's attributes
                link.href = URL.createObjectURL(blob);
                link.download = fileName;

                // Append the link to the document body
                document.body.appendChild(link);

                // Trigger a click event on the link
                link.click();

                // Remove the link from the document
                document.body.removeChild(link);
            })
            .catch((error) => {
                console.error('Error fetching image:', error);
            });
    };

    downloadImage();
    toast.success(`An image of your configured door selections has been downloaded successfully`, {
        timeout: 2000,
    });
};

onMounted(() => {
    // const lsToken = localStorage.getItem('authToken');
    // if (lsToken) {
    //     savedAuthToken.value = lsToken;
    //     store.state.authToken = lsToken;
    // }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Cta, {
      type: "secondary",
      size: "lg",
      label: "Add to Wishlist",
      onOnClick: _cache[0] || (_cache[0] = ($event: any) => (addToWishlist())),
      icon: ['fasr', 'heart'],
      iconAlignment: "left"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Cta, {
        type: "secondary",
        size: "lg",
        useLabelAsTitleOnly: true,
        label: "Download",
        icon: ['fa-light', 'fa-down-to-line'],
        onOnClick: _cache[1] || (_cache[1] = ($event: any) => (download())),
        iconAlignment: "left",
        noIconPadding: true
      }),
      _createVNode(Cta, {
        type: "secondary",
        size: "lg",
        useLabelAsTitleOnly: true,
        label: "Print",
        icon: ['fasl', 'fa-print'],
        iconAlignment: "left",
        onOnClick: _cache[2] || (_cache[2] = ($event: any) => (print())),
        noIconPadding: true
      }),
      _createVNode(Cta, {
        type: "secondary",
        size: "lg",
        useLabelAsTitleOnly: true,
        label: "Share",
        icon: ['fa-light', 'fa-share-nodes'],
        iconAlignment: "left",
        onOnClick: _cache[3] || (_cache[3] = ($event: any) => (share())),
        noIconPadding: true
      })
    ]),
    _createVNode(Cta, {
      type: "secondary",
      size: "lg",
      label: "Advanced Filters",
      icon: ['fasl', 'fa-filter'],
      iconAlignment: "left",
      onOnClick: handleAdvancedFilters
    })
  ]))
}
}

})